<template>
  <div v-if="cancelOrder.dealList">
    <div class="urgentCon">
      <ul v-if="cancelOrder.dealList.length>0">
        <li v-for="(item,index) in cancelOrder.dealList" @click="showSub(index)">
          <div v-if="urgentCon=='record'" class="itemCon itemCancel">
            <span>#{{ item.pno }}</span>
            <span>{{ item.applyTime }}</span>
          </div>
          <div class="itemCon itemTit">
            <span>{{ item.symbol }}<em>#{{ item.positionId }}</em><img v-if="urgentCon=='close'" :class="{expand:activeSubIndex==index}" src="@/assets/images/template/user_arrow.png"></span>
            <p>{{ item.guadanTime }}</p>
          </div>
          <div class="itemCon">
            <div class="item"><p class="p_mode" :class="item.directionName=='买'?'buy':'sell'">{{ item.directionName }}{{ item.directionName=='买'?'入':'出' }}</p><span>{{ item.volume }}手</span></div>
            <div class="item"><p class="marginRight">挂单价</p><span>{{ item.openPrice }}</span></div>
            <div class="item"><p>止损</p><span>{{ item.stopLoss==''?'--':item.stopLoss }}</span></div>
          </div>
          <div class="itemCon">
            <div class="item marginLeft"><span>{{ item.expiretype }}</span></div>
            <div class="item"><p>止盈</p><span>{{ item.takeProfit==''?'--':item.takeProfit }}</span></div>
          </div>
          <span v-if="activeSubIndex==index" class="btn" @click="cancelOrderPop(item.positionId)">撤单</span>
        </li>
      </ul>
      <noData v-else />
    </div>
    <div v-if="cancelOrder.dealList.length>0" class="more" :class="moreClass" @click="clickMore"><span>{{ moreTxt }}</span></div>
    <!--撤单提醒-->
    <div v-if="isCancelOrder&&urgentCon=='close'" class="popFixed">
      <div class="masking" @click="cancelOrderPop(0)" />
      <div class="tcCon">
        <div class="item">
          <span>撤单提醒</span>
          <p>确定要对当前订单进行撤单操作吗？</p>
        </div>
        <div class="btnCon">
          <span @click="cancelOrderPop(0)">取消</span>
          <span @click="submit">确定</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import noData from '@/view/module/noData.vue'
import api from '@/plugins/api'

export default {
  name: 'CancelOrder',
  components: { noData },
  props: ['platform', 'urgentCon'],
  data() {
    return {
      isCancelOrder: false,
      activeSubIndex: -1,
      orderId: '',
      cancelOrder: '',
      cancelOrderNum: 10,
      moreTxt: ''
    }
  },
  computed: {
    moreClass: {
      get() {
        let classType = ''
        if (this.cancelOrder.dealList) {
          if (this.cancelOrder.dealList.length >= 10 && this.cancelOrder.totalPage > 1) {
            this.moreTxt = '加载更多'
            classType = ''
          } else {
            this.moreTxt = '没有更多数据'
            classType = 'noData'
          }
          return classType
        }
      }
    }
  },
  watch: {
    platform: function() {
      this.initData()
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      const data = {
        index: 1,
        pageSize: 10,
        platform: this.platform,
        type: this.urgentCon == 'close' ? 'unGuaDan' : 'guaDan'
      }
      this.cancelOrderData(data)
    },
    cancelOrderData(data) {
      api.getDealList(this.$qs.stringify(data)).then(res => {
        if (res.data.code == 200) {
          this.cancelOrder = res.data.data
        }
      })
    },
    clickMore() {
      let data = {}
      if (this.moreTxt == '加载更多') {
        this.cancelOrderNum += 10
        data = {
          index: 1,
          pageSize: this.cancelOrderNum,
          platform: this.platform,
          type: this.urgentCon == 'close' ? 'unGuaDan' : 'guaDan'
        }
        this.cancelOrderData(data)
      }
    },
    showSub(index) {
      if (this.urgentCon == 'close') {
        this.activeSubIndex = this.activeSubIndex == index ? -1 : index
      }
    },
    cancelOrderPop(orderId) {
      if (orderId != 0) {
        this.orderId = orderId
      }
      this.isCancelOrder = !this.isCancelOrder
    },
    submit() {
      const data = {
        orderId: this.orderId
      }
      api.closeOrder(this.$qs.stringify(data)).then(res => {
        if (res.data.code == 200) {
          this.isCancelOrder = false
          this.activeSubIndex = -1
          this.initData()
        }
      })
    }
  }
}
</script>
